import { billingPlanSchema, subscriptionSchema, type BillingPlan } from "@repo/shared";
import { z } from "zod";

import { API_V1_PREFIX, apiRequestJson } from "../api-client";

// ─── Response schemas ──────────────────────────────────────────────────────────

const subscriptionDetailSchema = z.object({
  subscription: subscriptionSchema,
  plan: billingPlanSchema.transform((p) => {
    const limits = (p.metadata as { limits?: BillingPlan["limits"] } | undefined)?.limits ?? {
      connections: 0,
      groups: 0,
      appsPerGroup: 0,
      jobsPerMonth: 0,
      analysesPerMonth: 0,
      qvdAnalysesPerMonth: 0,
      members: 0,
    };
    return { ...p, limits };
  }),
  usage: z.record(z.string(), z.number()).optional(),
});

const subscriptionResponseSchema = z.object({ data: subscriptionDetailSchema });

// ─── API functions ──────────────────────────────────────────────────────────────

export type SubscriptionDetail = z.infer<typeof subscriptionDetailSchema>;

export async function getSubscription(): Promise<SubscriptionDetail> {
  const response = await apiRequestJson({
    path: `${API_V1_PREFIX}/billing/subscription`,
    responseSchema: subscriptionResponseSchema,
    badResponseMessage: "Unexpected response when loading subscription",
  });
  return response.data;
}
